



























import mixins from 'vue-typed-mixins';
import { SubOrgOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => SubOrgOptions,
    },
  },
  mounted() {
    // set  values to defaults
    this.$emit('input', {
      singlelabel:
        this.value.singlelabel ||
        this.$languageobj(
          'model.question.options.sub_organization.singlelabel.default'
        ),
      multilabel:
        this.value.multilabel ||
        this.$languageobj(
          'model.question.options.sub_organization.multilabel.default'
        ),
      ...this.value,
    });
  },
});
